import KeyFlowVO from 'commons/vo/KeyFlowVO';

type CategoryVOProps = {
  ID: number;
  NAME: string;
  STORAGEID: number;
  BACKUPSTORAGEID: number;
  CAPACITY: number;
  MAXSIZE: number;
  TOTALVIDEOSIZE: number;
  TOTALAUDIOSIZE: number;
  TOTALIMAGESIZE: number;
  TOTALFILESIZE: number;
  CAN_INGEST: number;
  IS_DELETED: number;
  ORDER_SEQ: number;
  CREATEDATE: string;
  CREATEUSER: string;
  MODIFYDATE: string;
  MODIFYUSER: string;
};

class CategoryVO extends KeyFlowVO {
  id: number;
  name: string;
  storageId: number;
  backupStorageId: number;
  capacity: number;
  maxSize: number;
  totalVideoSize: number;
  totalAudioSize: number;
  totalImageSize: number;
  totalFileSize: number;
  canIngest: number;
  isDeleted: number;
  orderSeq: number;
  createDate: string;
  createUser: string;
  modifyDate: string;
  modifyUser: string;

  constructor(data: CategoryVOProps) {
    super(data);
    this.id = data.ID;
    this.name = data.NAME;
    this.storageId = data.STORAGEID;
    this.backupStorageId = data.BACKUPSTORAGEID;
    this.capacity = data.CAPACITY;
    this.maxSize = data.MAXSIZE;
    this.totalVideoSize = data.TOTALVIDEOSIZE;
    this.totalAudioSize = data.TOTALAUDIOSIZE;
    this.totalImageSize = data.TOTALIMAGESIZE;
    this.totalFileSize = data.TOTALFILESIZE;
    this.canIngest = data.CAN_INGEST;
    this.isDeleted = data.IS_DELETED;
    this.orderSeq = data.ORDER_SEQ;

    this.createDate = data.CREATEDATE;
    this.createUser = data.CREATEUSER;
    this.modifyDate = data.MODIFYDATE;
    this.modifyUser = data.MODIFYUSER;
  }
}

export default CategoryVO;
